import { render, staticRenderFns } from "./OtherInvoices.vue?vue&type=template&id=67304046&scoped=true&"
import script from "./OtherInvoices.vue?vue&type=script&lang=js&"
export * from "./OtherInvoices.vue?vue&type=script&lang=js&"
import style0 from "./OtherInvoices.vue?vue&type=style&index=0&id=67304046&prod&lang=scss&scoped=true&"
import style1 from "./OtherInvoices.vue?vue&type=style&index=1&id=67304046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67304046",
  null
  
)

export default component.exports